import React from 'react'
import { Element } from 'react-scroll'
const Samples = () => {
    return (
        <>
            <Element name='Samples'>
                <h1 className="text-center text-light fw-bold display-4 pb-5 ">Samples</h1>
                <div className=" downGradient">
                    <div className="container">
                        <div className="row py-2">
                            <div className="col-12 col-md-8 d-flex justify-content-center  order-2 order-md-1 py-2">
                                <img src="https://marketingartfully.com/wp-content/uploads/2022/01/2021-youtube-stats-1024x583.jpg" alt="" className="card-img-top w-75 rounded-4" />
                            </div>
                            <div className="col-12 col-md-4 order-1 order-md-2 justify-content-md-start justify-content-center d-flex align-items-center">
                                <div className="w-25 d-md-none">
                                    <img src="https://static01.nyt.com/images/2024/08/01/multimedia/01xp-mrbeast1-ktqv/01xp-mrbeast1-ktqv-mediumSquareAt3X.jpg" alt="" className="card-img-top w-100 rounded-5" />
                                </div>
                                <div className="w-50 d-none d-md-block">
                                    <img src="https://static01.nyt.com/images/2024/08/01/multimedia/01xp-mrbeast1-ktqv/01xp-mrbeast1-ktqv-mediumSquareAt3X.jpg" alt="" className="card-img-top w-100 rounded-5" />
                                </div>
                            </div>
                        </div>
                        <div className="row py-2">
                            <div className="col-12 col-md-8 d-flex justify-content-center  order-2 order-md-1 py-2">
                                <img src="https://marketingartfully.com/wp-content/uploads/2022/01/2021-youtube-stats-1024x583.jpg" alt="" className="card-img-top w-75 rounded-4" />
                            </div>
                            <div className="col-12 col-md-4 order-1 order-md-2 justify-content-md-start justify-content-center d-flex align-items-center">
                                <div className="w-25 d-md-none">
                                    <img src="https://static01.nyt.com/images/2024/08/01/multimedia/01xp-mrbeast1-ktqv/01xp-mrbeast1-ktqv-mediumSquareAt3X.jpg" alt="" className="card-img-top w-100 rounded-5" />
                                </div>
                                <div className="w-50 d-none d-md-block">
                                    <img src="https://static01.nyt.com/images/2024/08/01/multimedia/01xp-mrbeast1-ktqv/01xp-mrbeast1-ktqv-mediumSquareAt3X.jpg" alt="" className="card-img-top w-100 rounded-5" />
                                </div>
                            </div>
                        </div>
                        <div className="row py-2">
                            <div className="col-12 col-md-8 d-flex justify-content-center  order-2 order-md-1 py-2">
                                <img src="https://marketingartfully.com/wp-content/uploads/2022/01/2021-youtube-stats-1024x583.jpg" alt="" className="card-img-top w-75 rounded-4" />
                            </div>
                            <div className="col-12 col-md-4 order-1 order-md-2 justify-content-md-start justify-content-center d-flex align-items-center">
                                <div className="w-25 d-md-none">
                                    <img src="https://static01.nyt.com/images/2024/08/01/multimedia/01xp-mrbeast1-ktqv/01xp-mrbeast1-ktqv-mediumSquareAt3X.jpg" alt="" className="card-img-top w-100 rounded-5" />
                                </div>
                                <div className="w-50 d-none d-md-block">
                                    <img src="https://static01.nyt.com/images/2024/08/01/multimedia/01xp-mrbeast1-ktqv/01xp-mrbeast1-ktqv-mediumSquareAt3X.jpg" alt="" className="card-img-top w-100 rounded-5" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Element>
        </>
    )
}

export default Samples